/**
 * Cosmos returns 200 for both valid and invalid OTPs. Only a runtime-valid
 * verified:true body grants verification; 204 is not this endpoint's contract.
 * Error codes remain available through ApiError.code. The tenant-scoped invite
 * endpoint has a separate 204 contract and is not changed here (FW-314).
 */
import { useIdentityApiClient, useMutation, type UseMutationReturnType } from '@fusapp-work/shell'

export interface RegistrationVerifyOtpInput {
  readonly registrationToken: string
  readonly code: string
}

export interface RegistrationVerifyOtpResponse {
  readonly verified: boolean
  readonly remainingAttempts: number
}

export function useRegistrationVerifyOtp(): UseMutationReturnType<RegistrationVerifyOtpResponse, Error, RegistrationVerifyOtpInput, unknown> {
  const apiClient = useIdentityApiClient()
  return useMutation({
    mutationFn: (body: RegistrationVerifyOtpInput) =>
      apiClient.request<RegistrationVerifyOtpResponse>('/api/v1/registration/verify-otp', { method: 'POST', body }),
  })
}
